import {
    showValidationErrors,
    clearValidationErrors,
    showValidationError,
    hideValidationError,
    initMaskedInput,
    scrollToElement,
    isMobile
} from '../../common/functions';
import { showLoader, hideLoader } from '../../globalFunctions';
import { showMessage } from '../../utils/showMessage';
import {getCurrentCaptchaType, insertCaptcha, reloadCaptcha, getRecaptchaV3PublicKey} from '../../captcha';
import { kebabToCamelCase } from '../../utils/kebabToCamelCase';
import { getQueryParam } from '../../utils/getQueryParam';
import { loadStyleAsync } from '../../utils/loadResourceAsync';
import { htmlDecode } from '../../utils/htmlDecode';
import { logError } from '../../utils/logError';
import { ready } from '../../utils/ready';
import { loadDolyameModal} from '../../async/loadDolyameModal.js';
import { loadDropzone } from '../../async/loadDropzone.js';
import {
    autoLoadPrkGalleries,
    loadPhotoSwipe,
    loadPhotoSwipeLightbox,
    loadPrkPhotoSwipeThumbnails,
    loadPrkPhotoSwipeImageAutoSize
} from '../../async/loadPhotoSwipe.js';
import { loadGrecaptcha } from '../../async/loadGrecaptcha.js';
import { loadJQuery } from '../../async/loadJQuery.js';
import { loadPrkModal } from '../../async/loadPrkModal.js';
import { loadRating } from '../../async/loadRating.js';
import {prkModalConfigs} from '../../common/hashed-links-handlers';
import { Reviews } from './../../prk/reviews';
import URLQueryParams from '/js/url-query-params';
import {prkCollapsibleConfigs} from "../../prk/prk-collapsible/handlers";
import { initSubscribeForm } from '../../common/subscribe';
import { sanitizeUserInput } from '../../utils/sanitizeUserInput';
import { ProductPhotoVideoGallery } from './product-photo-video-gallery';
import sleep from '../../utils/sleep';
import { ErrorWithContext } from '../../error-with-context.js';

/**
 * Initializes request better description/photos forms
 */
async function initAjaxForms () {
    /**
     * @this {HTMLFormElement}
     * @param {SubmitEvent} event
     */
    const onFormSubmit = async function(event) {
        event.preventDefault();

        const form = this;
        const inputs = [...form.querySelectorAll('input, textarea')];

        // Collect form fields' data
        const formData = new FormData;
        for (const input of inputs) {
            if (!input.name) continue;
            const value = 'checkbox' === input.type
                ? input.checked
                : input.value;
            formData.append(input.name, value);
        }

        // Show spinner and disable form
        form.setAttribute('disabled', 'disabled');

        const actionV3 = form.id;
        loadGrecaptcha().then(() => {
            grecaptcha.ready(() => {
                grecaptcha.execute(getRecaptchaV3PublicKey(), { action: actionV3 })
                    .then(async tokenV3 => {
                        try {
                            // Add captcha validation tokens
                            formData.append('token_v3', tokenV3);
                            formData.append('action_v3', actionV3);

                            const response = await fetch(form.action, {
                                headers: {
                                    'X-Requested-With': 'XMLHttpRequest',
                                },
                                method: form.method,
                                body: formData,
                            });
                            const responseData = await response.json();
                            const PrkModal = await loadPrkModal();
                            (new PrkModal(form)).close();
                            showMessage(responseData.message);
                        } catch (error) {
                            const PrkModal = await loadPrkModal();
                            (new PrkModal(form)).close();
                            showMessage(error?.context?.extra?.originalMessage ?? 'Что-то пошло не так. Попробуйте, пожалуйста, позже');
                        } finally {
                            // Hide spinner and enable form
                            form.removeAttribute('disabled');
                        }
                    })
                    .catch(error => {
                        logError(`Grecaptcha: ${(error ? JSON.stringify({ error }) : 'Неизвестная ошибка')}`);
                        showMessage('Ошибка капчи, попробуйте ещё раз');
                        hideLoader(form);

                        // Hide spinner and enable form
                        form.removeAttribute('disabled');
                    });
            });
        });
    }

    for (const form of [...document.querySelectorAll('#need_mg_pics, #need_mg_desc')]) {
        form.addEventListener('submit', onFormSubmit.bind(form));
    }
}

export function addClickHandlers() {
    /**
     * Scrolls to the tab and activates it
     * @param {string} tabName
     */
    function scrollProductDetailsPageToTab (tabName) {
        $(`.tabs li[data-attr_prop="${tabName}"]`).click();
        const scrollTarget = tabName === 'reviews' && $('.detail-product-footer > #tab-content-reviews').length
            ? document.getElementById('tab-content-reviews')
            : document.getElementById('tab-properties');
        scrollToElement(scrollTarget);
    }

    // Scroll to Properties tabs in product-detail-footer
    $(document).on('click', '.js-show-tab-properties, .js-show-tab-advantages, .js-show-tab-reviews, .js-show-tab-questions, .js-show-tab-video-review, .js-show-tab-instructions-and-certificates', function (event) {
        event.preventDefault();
        const tabName = kebabToCamelCase(this.className.replace(/.*js-show-tab-([\w-]+).*/, '$1'));
        scrollProductDetailsPageToTab(tabName);
    });

    // Make sure that when given a link to one of the #tab-properties tabs
    // on product-detail page, the page is scrolled to that tab
    if (window.location?.hash) {
        try {
            const $tab = $(`.tabs-buttons__item${window.location.hash}`);
            if ($tab.length) {
                scrollProductDetailsPageToTab($tab.data('attr_prop'));
            }
        } catch (error) {
            if (error instanceof DOMException) {
                // Do nothing because
                // window.location.hash appears to be invalid element id
                // and fails to be parsed as selector
            } else {
                logError(error, {
                    extra: {
                        hash: window.location.hash,
                    },
                });
            }
        }
    }

    //TABS TO SELECT EXECUTE
    $(document).on('click', 'div.tabs.selectbox .selectbox-title', function(){
        $(this).parents('.tabs__header').find('.tabs-buttons').addClass('open');
        $(this).parents('.tabs__header').find('.tabs-buttons').toggle();
    });
    $(document).on('click', 'div.tabs.selectbox .tabs-buttons li', function(){
        $(this).parents('.tabs__header').find('.selectbox-title').find('span.title').text($(this).text());
        $(this).parents('.tabs-buttons.open').toggle();
        $(this).parents('.tabs__header').find('.tabs-buttons').removeClass('open');
    });

    // Show loaders
    $(document).on('click', '#need_mg_pics form button[type=submit]', function(){
        showLoader($('#need_mg_pics'));
    });
    $(document).on('click', '#need_mg_desc form button[type=submit]', function(){
        showLoader($('#need_mg_desc'));
    });

    initAjaxForms();

    // Tab-properties responsive scripts
    $(window).on('resize', function() {
        //TRANSFORM TABS TO SELECT
        enableSelectBoxes();
    });
    ready(function() {
        //TRANSFORM TABS TO SELECT
        enableSelectBoxes();
    });
    function enableSelectBoxes() {
        if (window.innerWidth <= 570) {
            $('.tabs-buttons').hide();
            $('div.tabs').addClass('selectbox');
        } else {
            $('.tabs-buttons').removeClass('open').css('display', 'inline-flex');
            $('div.tabs').removeClass('selectbox');
        }
    }

    autoLoadPrkGalleries();
}

// Add main product image zoom and gallery
export async function initProductPhotoVideoGallery() {
    let mainProductGallery = document.querySelector('.product-photos');
    let videoReviewsGallery = document.querySelector('.product-video-reviews');

    if (mainProductGallery) {
        mainProductGallery = new ProductPhotoVideoGallery(mainProductGallery, {
            navElementClass: 'product-photos__nav',
            navSliderClass: 'product-photos__nav-slider',
            navDirection: mainProductGallery.classList.contains('product-photos--vertical')
                ? 'vertical'
                : 'horizontal',
            navItemClass: 'product-photos__nav-item',
            navPrevButtonClass: 'product-photos__nav-button--prev',
            navNextButtonClass: 'product-photos__nav-button--next',
            displayElementClass: 'product-photos__display',
            imageElementClass: 'product-photos__image',
            zoomImages: !isMobile(),
            onNavigate: (item) => {
                if (!item.classList.contains('js-product-videos'))
                    return;


            }
        });
    }

    if (videoReviewsGallery) {
        videoReviewsGallery = new ProductPhotoVideoGallery(videoReviewsGallery, {
            navElementClass: 'product-video-reviews__nav',
            navSliderClass: 'product-video-reviews__nav-slider',
            navDirection: 'vertical',
            navItemClass: 'product-video-reviews__nav-item',
            displayElementClass: 'product-video-reviews__video',
            zoomImages: false,
        });
    }
}

export async function initProductPhotosByUsersGallery() {
    /** @var {HTMLAnchorElement[]} thumbElements */
    const thumbElements = [...document.querySelectorAll('.js-product-photos-by-users-item')];

    /** @var {Array<{ detail: string, preview: string }>} userPhotosData */
    let userPhotosData;
    try {
        userPhotosData = JSON.parse(document.getElementById('product-photos-by-users-data')?.textContent.trim() || '[]');
    } catch (error) {
        userPhotosData = [];
        logError(error);
    }

    try {
        const [PhotoSwipe, PhotoSwipeLightbox, PrkPhotoSwipeImageAutoSize, PrkPhotoSwipeThumbnails] = await Promise.all([
            loadPhotoSwipe(),
            loadPhotoSwipeLightbox(),
            loadPrkPhotoSwipeImageAutoSize(),
            loadPrkPhotoSwipeThumbnails(),
        ]);

        const options = {
            pswpModule: PhotoSwipe,
            dataSource: userPhotosData.map(photo => ({
                src: photo.detail,
                width: 1280,
                height: 1280,
                msrc: photo.preview,
                thumbWidth: 120,
                thumbHeight: 120,
                thumbCropped: true,
                autoSize: 'height',
            })),
        }

        const lightbox = new PhotoSwipeLightbox(options);

        // Define zoom animation targer for thumbs
        // that are stacked into the last thumb element
        lightbox.addFilter('thumbEl', (thumbEl, data, index) => {
            for (let i = Math.min(index, thumbElements.length - 1); i >= 0; i--) {
                if (getComputedStyle(thumbElements[i])['display'] !== 'none')
                    return thumbElements[i];
            }

            return thumbElements[0];
        });

        new PrkPhotoSwipeImageAutoSize(lightbox);
        new PrkPhotoSwipeThumbnails(lightbox, {
            isMobile: document.querySelector('.mob#wrapper') !== null,
        });

        lightbox.init();

        const openGallery = async function(event) {
            event.preventDefault();
            lightbox.loadAndOpen(thumbElements.indexOf(event.currentTarget));
        }

        for (const thumb of thumbElements) {
            thumb.addEventListener('click', openGallery);
        }
    } catch (error) {
        logError(error);
    }
}

// Check if product in comparing list at page has rendered
function checkIfProductInComparingList(productId, checkBox, textContainer) {
    fetch(`/api/prk/compare/checkIfProductInComparing.php?${new URLQueryParams({ 'product_id': productId })}`, {
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    })
        .then(response => response.json())
        .then(response => {
            if (response === true) {
                checkBox.checked = true;
                textContainer.text('К сравнению');
                textContainer.addClass('active');
            }
        })
        .catch(logError);
}

// Adds product reviews behaviour
export async function addProductReviewsLogic() {
    await loadJQuery();
    const grecaptchaV3PublicKey = getRecaptchaV3PublicKey();
    let isModalLoaded = false;
    let isModalLoading = false;
    let isReviewRulesModalLoaded = false;
    let isReviewRulesModalLoading = false;
    let shouldReopenAddCommentDialog = false;

    const initDropZone = async function () {
        const PrkModal = await loadPrkModal();
        const addCommentDialog = new PrkModal(document.getElementById('add_comment'));
        const dropzoneElement = document.getElementById('drop_product_preview_attachments');
        if (!dropzoneElement) return;

        const dropzone = new Dropzone('#drop_product_preview_attachments', {
            url: '/api/prk/catalog/product/review/attachment/index.php',
            createImageThumbnails: true,
            addRemoveLinks: true,
            maxFiles: 10,
            maxFilesize: 30,
            parallelUploads: 2,
            acceptedFiles: '.jpeg, .jpg, .png',
            params: {
                action: 'upload'
            },
            dictDefaultMessage: 'Перетащите файл с фото в это поле для загрузки (разрешенные форматы: .jpeg, .jpg, .png)',
            dictFileTooBig: 'Максимальный размер файла: 30 Мб',
            dictInvalidFileType: 'Неверный тип файла',
            dictMaxFilesExceeded: 'Разрешена загрузка не более 10 файлов',
            dictCancelUpload: 'Остановить загрузку',
            dictRemoveFile: 'Удалить файл',
            success: function (file, response) {
                if (response && response.attachment_hash) {
                    const input = addCommentDialog.modal.querySelector('input[name="attachments"]');
                    const fileHashes = input.value.split(',').filter(function (item) {
                        return !!item;
                    });

                    if (-1 === fileHashes.indexOf(response.attachment_hash))
                        fileHashes.push(response.attachment_hash);

                    if (fileHashes.length > 10) {
                        fileHashes.slice(0, 10);
                    }

                    input.value = fileHashes.join(',');
                }
            }
        });
        dropzone.on('removedfile', function (file) {
            try {
                const response = JSON.parse(file.xhr?.response ?? 'null');
                if (response && response.attachment_hash) {
                    const input = addCommentDialog.modal.querySelector('input[name="attachments"]');
                    if (!input)
                        return;

                    const fileHashes = input.value.split(',').filter(function (item) {
                        return !!item;
                    });

                    const index = fileHashes.indexOf(response.attachment_hash);
                    if (-1 < index) {
                        fileHashes.splice(index, 1);
                    }

                    input.value = fileHashes.join(',');
                }
            } catch (error) {logError(error);}
        });
        const attachments = addCommentDialog.modal.querySelector('[validate="attachments"]');
        if (attachments) {
            attachments.style.display = '';
        }
    }

    const handleFormSubmit = async event => {
        event.preventDefault();

        const PrkModal = await loadPrkModal();
        const addCommentDialog = new PrkModal(document.getElementById('add_comment'));
        const commentInputs = [...addCommentDialog.modal.querySelectorAll('[name="qualities"], [name="drawbacks"], [name="comment"]')];
        const commentLength = commentInputs.reduce((commentLength, input) => commentLength + sanitizeUserInput(input.value ?? '').length, 0);

        const ratingInput = addCommentDialog.modal.querySelector('[name="rating"]');
        if (ratingInput && ratingInput.value === '0') {
            showValidationError(
                $(`[name="rating"]`),
                'Необходимо указать оценку товара'
            );

            return;
        }

        // If length of comment, qualities and drawbacks is less then 1
        // Show error message on comment input
        if (commentLength < 1) {
            showValidationError(
                $(`[name="comment"]`),
                'Необходимо заполнить хотя бы одно из полей "достоинства", "недостатки" или "комментарий"'
            );
            return;
        }

        showLoader($(addCommentDialog.modal));

        grecaptcha.ready(() => {
            const $form = jQuery(addCommentDialog.modal).find('form');
            const grecaptchaV3CurrentAction = window.poryadokPageType ? window.poryadokPageType : 'other_page';

            clearValidationErrors($form[0]);

            grecaptcha.execute(grecaptchaV3PublicKey, {action: grecaptchaV3CurrentAction}).then(tokenV3 => {
                // Construct data object
                const data = Object.assign(
                    $form.serializeArray().reduce((data, item) => {
                        if ('' !== item.value) {
                            data[item.name] = 'rating' === item.name
                                ? parseInt(item.value)
                                : item.value;
                        }
                        return data;
                    }, {}),
                    {
                        token_v3: tokenV3,
                        action_v3: grecaptchaV3CurrentAction
                    }
                );

                fetch($form.attr('action'), {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    body: JSON.stringify(data),
                })
                    .then(response => {
                        if (response.ok) return response.json();

                        throw response;
                    })
                    .then(response => {
                        hideLoader($(addCommentDialog.modal));

                        // If all ok
                        if (!response.captcha) {
                            addCommentDialog.close();
                            showMessage(response.message);

                            // Reset form
                            addCommentDialog.modal.innerHTML = '';
                            isModalLoaded = false;
                        }
                        // else if Grecaptcha needs action
                        else if (response.captcha && response.captcha.captcha_to_insert) {
                            insertCaptcha(response.captcha.captcha_to_insert);
                            $('.js-captcha-container').removeClass('hidden');
                        }
                        else {
                            reloadCaptcha(getCurrentCaptchaType());
                        }
                    })
                    .catch(/** @param {ErrorWithContext|Error} error */ (error) => {
                        const { jsonData = null, status = 500, originalMessage = 'Ошибка, попробуйте позже' } = error?.context?.extra ?? {};
                        hideLoader($(addCommentDialog.modal));

                        // Validation error
                        if (422 === status) {
                            const validationErrors = jsonData?.validation_errors;
                            if (validationErrors)
                                showValidationErrors($form[0], validationErrors);
                            else {
                                addCommentDialog.close();
                                showMessage(originalMessage);
                            }
                        }

                        // Show other errors
                        else {
                            logError(error);
                            addCommentDialog.close();
                            showMessage(originalMessage);
                        }
                    });
            })
            .catch(error => {
                hideLoader($(addCommentDialog.modal));
                const errorMessage = `Grecaptcha: ${(error ? JSON.stringify({ error }) : 'Неизвестная ошибка')}`;
                logError(errorMessage);
                addCommentDialog.close();
                showMessage('Ошибка сети, попробуйте позже');
            });
        });
    };

    /**
     * Loads review publication rules addCommentDialog.modal
     */
    const loadRulesModal = async function () {
        const PrkModal = await loadPrkModal();
        const addCommentDialog = new PrkModal(document.getElementById('add_comment'));
        const reviewRulesDialog = new PrkModal(document.getElementById('product-review-rules'));
        addCommentDialog.close();
        if (isReviewRulesModalLoaded || isReviewRulesModalLoading)
            return;

        isReviewRulesModalLoading = true;
        showLoader($(reviewRulesDialog.modal));

        Promise.all([
            fetch('/include/catalog/product/add-comment/rules/', {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            }).then(response => response.text()),
            loadStyleAsync('/css/catalog/product-details/review-rules-modal.css')
        ])
            .then(response => {
                reviewRulesDialog.modal.innerHTML = response[0];
                isReviewRulesModalLoaded = true;
            })
            .catch(reason => {
                console.error(reason);
                logError(reason) // log error to Sentry
                reviewRulesDialog.close();
            })
            .then(() => {
                isReviewRulesModalLoading = false;
                hideLoader($(reviewRulesDialog.modal));
            })
    };

    /**
     * Loads add comment addCommentDialog.modal and its dependancies
     */
    const loadModal = async function () {
        // If already loaded then return
        if (isModalLoaded || isModalLoading)
            return;

        showLoader($(this.modal));
        isModalLoading = true;

        const productCode = this.modal.dataset.productCode || null;
        const orderNumber = getQueryParam('order_number') || '';

        Promise.all([
            fetch(`/include/catalog/product/add-comment/?${new URLQueryParams({ code: productCode, order_number: orderNumber })}`, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            }).then(response => response.text()), // Form itself
            loadGrecaptcha(), // Grecaptcha
            loadDropzone(), // Dropzone js module and styles
            loadRating(), // Star rating input
            loadStyleAsync('/css/catalog/product-details/add-comment-modal-v2.css') // From css
        ])
            // Let styles and be rendered before processing
            .then(responses => new Promise(resolve => setTimeout(() => resolve(responses))))
            .then(responses => {
                // Parse html and init
                this.modal.innerHTML = responses[0];
                initDropZone();

                jQuery(this.modal).find('input.rating').rating();

                $(this.modal).find('form')
                    .on('submit', handleFormSubmit)
                    .find('input, select')
                        .on('keypress', event => {
                            // On Enter pressed, send the form
                            if ((event.code && event.code === 'Enter') || ((event.keyCode ||event.which) === 13)) {
                                event.stopPropagation();
                                handleFormSubmit(event);
                            }
                        });

                $(this.modal).find('[href="#product-review-rules"]')
                    .on('click', () => shouldReopenAddCommentDialog = true);

                initListenerChangeLengthFeedback();

                isModalLoaded = true;
            })
            .catch(reason => {
                console.error(reason);
                logError(reason) // log error to Sentry
                this.close();
            })
            .then(() => {
                isModalLoading = false;
                hideLoader($(this.modal));
            });
    };

    const openAddCommentModalAfterRulesClose = async function () {
        if (shouldReopenAddCommentDialog) {
            const PrkModal = await loadPrkModal();
            const addCommentDialog = new PrkModal(document.getElementById('add_comment'));
            shouldReopenAddCommentDialog = false;
            addCommentDialog.open();
        }
    }

    prkModalConfigs['add_comment'] = { onOpen: loadModal };
    prkModalConfigs['product-review-rules'] = { onOpen: loadRulesModal, onClose: openAddCommentModalAfterRulesClose }

    $(document)
        .on('input', '#add_comment .form-control', async function () {
            // Hide validation messages on user input
            // on any input element
            hideValidationError($(this));

            const PrkModal = await loadPrkModal();
            const addCommentDialog = new PrkModal(document.getElementById('add_comment'));

            // In case of 'comment' and 'qualities' input,
            // hide error message on both
            if (this.hasAttribute('name')) {
                switch (this.getAttribute('name')) {
                    case 'qualities':
                        hideValidationError($(addCommentDialog.modal).find('[name="comment"]'));
                        break;

                    case 'comment':
                        hideValidationError($(addCommentDialog.modal).find('[name="qualities"]'));
                        break;
                }
            }
        });

}

// Adds social proof block
export function addSocialProofBlock() {
    // Social proof messages on detail product page
    const socialProofMessages = $('.js-social-proof-messages').val();
    if (socialProofMessages) {
        try {
            // Decode message texts
            const unescapedSocialProofMessages = htmlDecode(socialProofMessages),
                  spMessages = JSON.parse(unescapedSocialProofMessages);

            // Just in case
            if (!(spMessages instanceof Array) || spMessages.length === 0)
                return;

            // Gerate html for messages, append to the DOM and show sp messages block
            const $spMessagesBlock = $('.js-sp-message-container'),
                  $messagesContainer = $('.js-messages'),
                  messagesHTML = spMessages.map(message => `<div class="message js-message"><div class="message-text js-message-text">${message}</div></div>`).join('');

            $messagesContainer.append(messagesHTML);
            $spMessagesBlock.fadeIn('fast');

            // Prepare variables for changing messages
            let messageIndex = 0;
            const $messages = $messagesContainer.find('.js-message'),
                  changeMessageInterval = 8000;

            // This function changes messages in order
            const toggleMessages = function () {
                const blinkSpeed = 500;
                $messages.hide().eq(messageIndex).fadeIn(blinkSpeed);
                messageIndex = (messageIndex + 1) % $messages.length;
            }

            // Make messages be changed once in while.
            toggleMessages()
            setInterval(toggleMessages, changeMessageInterval);

            // Attach handler to close the block with sp messages
            $spMessagesBlock.find('.js-close-btn').on('click', $spMessagesBlock.hide.bind($spMessagesBlock));
        } catch (error) {
            logError(error);
        }
    }
}

export const initReviewsBlock = function () {
    new Reviews(document.querySelector('.product-reviews-block'))
}

// Moved from component_epilog.php
export const initProductInStockInfoBlock = function () {
    // Set "Show city stores" handler
    $(document).on('click', '.js-city-store-list-container-toggle', function() {
        const $this = $(this),
              togglerTitle = $this.text(),
              $cityStoreListContainer = $('.js-city-store-list-container');

        $this.text(togglerTitle === 'Показать' ? 'Скрыть' :  'Показать');
        $cityStoreListContainer.toggle('fast');
    });
}

const initListenerChangeLengthFeedback = function(){
    const addCommentDialog = document.getElementById('add_comment');
    const commentElement = document.getElementById('comment');
    const qualitiesElement = document.getElementById('qualities');
    const drawbacksElement = document.getElementById('drawbacks');
    const commentBenefitLengthElement = addCommentDialog.querySelector('.comment-benefit-message__length');
    const commentBenefitMessageUncompleteElement = addCommentDialog.querySelector('.comment-benefit-message__uncomplete');
    const commentBenefitMessageCompleteElement = addCommentDialog.querySelector('.comment-benefit-message__complete');
    const limit = 125;

    if (!commentBenefitLengthElement ||
        !commentBenefitMessageUncompleteElement ||
        !commentBenefitMessageCompleteElement)
        return;

    commentBenefitLengthElement.textContent = limit;

    const inputHandler = function() {
        const comment = sanitizeUserInput(commentElement?.value ?? '');
        const qualities = sanitizeUserInput(qualitiesElement?.value ?? '');
        const drawbacks = sanitizeUserInput(drawbacksElement?.value ?? '');

        const commentLength = comment.length,
            qualitiesLength = qualities.length,
            drawbacksLength = drawbacks.length;

        const remainder = limit - commentLength - qualitiesLength - drawbacksLength;
        commentBenefitLengthElement.textContent = remainder;

        if (remainder <= 0) {
            commentBenefitMessageUncompleteElement.style.display = 'none';
            commentBenefitMessageCompleteElement.style.display = 'block';
        } else {
            commentBenefitMessageUncompleteElement.style.display = 'block';
            commentBenefitMessageCompleteElement.style.display = 'none';
        }
    }

    for (const element of [qualitiesElement, commentElement, drawbacksElement]) {
        element.addEventListener('input', inputHandler);
    }
}

export const initVariations = function () {
    prkCollapsibleConfigs['show-all-variations'] = {
        onBeforeExpand: async function (next) {
            $(this.element).parent().find('.variations__item').show();
            this.element.style.display = 'none';
            next();
        }
    };
}

export const initUnavailableProductLogic = async () => {
    const renderSubscriptionForm = async () => {
        const subscribePlace = document.querySelector('.js-subscription-form-for-unavailable-product');
        if (!subscribePlace) {
            return;
        }

        return fetch(`/include/subscribe_product_template.php?product_id=${subscribePlace.dataset.productId}`)
            .then(response => response.text())
            .then(subscribeFormHtmlTemplate => {
                subscribePlace.innerHTML = subscribeFormHtmlTemplate;
                initMaskedInput('.js-russian-phone-format');
                initSubscribeForm();
            })
            .catch(logError);
    }

    const renderProductUnavailableButton = () => {
        const place = document.querySelector('.js-product-unavailable-for-order-button');
        if (!place) {
            return;
        }

        const button = document.createElement('button');
        button.className = 'na btn center-block';
        button.innerHTML = 'Выбрать аналог';
        button.addEventListener('click', () => {
            scrollToElement(document.querySelector('#similar-products'));
        });
        place.parentNode.replaceChild(button, place);
    }

    try {
        await renderSubscriptionForm();
        renderProductUnavailableButton();

        if (window.location.hash === '#similar-products') {
            scrollToElement(document.querySelector('#similar-products'));
        }
    } catch (e) {
    }
}

export function initDolyamePaymentDetails() {
    const widgetClass = 'js-dolyame-payment-widget';
    const widget = document.querySelector(`.${widgetClass}`);

    if (!widget)
        return;

    let modal = null

    const showPaymentDetails = async function() {
        // When already loading modal
        if (widget.hasAttribute('disabled'))
            return;

        if (!modal) {
            try {
                widget.setAttribute('disabled', 'disabled');
                const [PrkModal, createPaymentDetailsModal] = await Promise.all([
                    loadPrkModal(),
                    loadDolyameModal(),
                ]);
                const modalElement = createPaymentDetailsModal(widget.dataset.paymentAmount * 4);
                document.body.appendChild(modalElement);

                // Let modal be rendered into DOM
                await sleep();

                modal = new PrkModal(modalElement, {
                    useHistory: false // Prevent modal from modifying hash
                });
                widget.removeAttribute('disabled');
            } catch (error) {
                logError(error);
            }
        }

        modal.open();
    }

    widget.addEventListener('click', showPaymentDetails);
}